function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { createSelector, createSelectorMemoized } from "../../../utils/createSelector.js";
import { gridRowTreeSelector, gridRowsLookupSelector } from "../rows/gridRowsSelector.js";
import { GRID_ID_AUTOGENERATED, isAutogeneratedRowNode } from "../rows/gridRowsUtils.js";
/**
 * @category Sorting
 * @ignore - do not document.
 */ var gridSortingStateSelector = function(state) {
    return state.sorting;
};
/**
 * Get the id of the rows after the sorting process.
 * @category Sorting
 */ export var gridSortedRowIdsSelector = createSelector(gridSortingStateSelector, function(sortingState) {
    return sortingState.sortedRows;
});
/**
 * Get the id and the model of the rows after the sorting process.
 * @category Sorting
 */ export var gridSortedRowEntriesSelector = createSelectorMemoized(gridSortedRowIdsSelector, gridRowsLookupSelector, gridRowTreeSelector, function(sortedIds, idRowsLookup, rowTree) {
    return sortedIds.reduce(function(acc, id) {
        var model = idRowsLookup[id];
        if (model) {
            acc.push({
                id: id,
                model: model
            });
        } else {
            var rowNode = rowTree[id];
            if (rowNode && isAutogeneratedRowNode(rowNode)) {
                acc.push({
                    id: id,
                    model: _define_property({}, GRID_ID_AUTOGENERATED, id)
                });
            }
        }
        return acc;
    }, []);
});
/**
 * Get the current sorting model.
 * @category Sorting
 */ export var gridSortModelSelector = createSelector(gridSortingStateSelector, function(sorting) {
    return sorting.sortModel;
});
/**
 * @category Sorting
 * @ignore - do not document.
 */ export var gridSortColumnLookupSelector = createSelectorMemoized(gridSortModelSelector, function(sortModel) {
    var result = sortModel.reduce(function(res, sortItem, index) {
        res[sortItem.field] = {
            sortDirection: sortItem.sort,
            sortIndex: sortModel.length > 1 ? index + 1 : undefined
        };
        return res;
    }, {});
    return result;
});
/**
 * @category Sorting
 * @ignore - do not document.
 */ export var gridSortedRowIndexLookupSelector = createSelectorMemoized(gridSortedRowIdsSelector, function(sortedIds) {
    return sortedIds.reduce(function(acc, id, index) {
        acc[id] = index;
        return acc;
    }, Object.create(null));
});
